export default "__VITE_ASSET__B66wr3cN__"